export default "//static.glanacion.com/v2/ingresar-nuevo/images/code-error.png";